import { useState } from 'react';

interface Toast {
  id?: string;
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
}

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const toast = (props: Toast) => {
    const id = props.id || Date.now().toString();
    const newToast = { ...props, id };

    setToasts((prev) => [...prev, newToast]);

    // Auto-remove after 5 seconds
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 5000);

    console.log(`Toast: ${props.variant === 'destructive' ? 'Error' : 'Info'} - ${props.title || ''} ${props.description || ''}`);
  };

  return { toast, toasts };
}